/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseObject from "@shared/BaseObject";
import {RecurrenceRangeType} from "@shared/Recurrence/RecurrenceEnums";

export default class RecurrenceRangeItem extends BaseObject{


	type: RecurrenceRangeType = null
	endDateTs: number = null
	numberOfOccurrences: number = 6
	masterNumberOfOccurrences: number = 0

	constructor() {
		super();
	}

	isTypeByCount(){
		return this.type == RecurrenceRangeType.COUNT
	}

	isTypeByDate(){
		return this.type == RecurrenceRangeType.BY_DATE
	}

	isTypeNoEnd(){
		return this.type == RecurrenceRangeType.NO_END
	}

	// equals(other){
	// 	if(!other || other.type != this.type || other.endDateTs != this.endDateTs || other.numberOfOccurrences != this.numberOfOccurrences){
	// 		return false
	// 	}
	// 	return true
	// }

}



